module.exports = __webpack_public_path__ + "img/TermsConditions.2f8f0d0a.svg";